import { createUseStyles } from 'react-jss'

export default createUseStyles({
  label: {
    color: 'var(--tips__form__label__text__color)',
    display: 'inline-block',
    fontSize: '12px',
    marginBottom: '8px',
    fontFamily: 'BentonSansMedium'
  }
})
